import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[right-aligned]',
})
export class UiTableRightAlignedDirective {
  @HostBinding('class') elClass = 'right-aligned';
}
